export const docsBasePath = '/api-doc';
export const siteOrigin = 'https://www.weex.com';
export const legacyDocsUrl = '/legacy-docs/spot/introduction/APIBriefIntroduction';

export function stripDocsBasePath(pathname) {
  if (pathname === docsBasePath) return '/';
  return pathname.startsWith(`${docsBasePath}/`) ? pathname.slice(docsBasePath.length) : pathname;
}
